export default __webpack_public_path__ + "static/media/treeQuiz.6aa3fab9.png";